import { Form } from 'react-bootstrap';
import styled from 'styled-components';

interface IProps {
  errorToDisplay: any;
}

export const Input = styled.div<IProps>`
  display: grid;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.3rem;
  margin-left: 4px;
  width: 100%;
  .label {
    font-size: 14px;
    color: black;
    text-align: left;
  }

  input {
    box-shadow: var(--color-input-shadow);
    border: ${({ errorToDisplay }) =>
      errorToDisplay
        ? '1px solid var(--error)'
        : '1px solid var(--color-input-border)'};
    border-radius: 4px;

    ::placeholder {
      font-size: 12px;
      color: var(--color-input-placeholder);
    }
  }

  .inputMask {
    font-size: 13px;
    width: 100%;
    padding: 0.8px 9px;
    border-radius: 4px;
    transition: all 0.08s ease-in-out;
    border: ${({ errorToDisplay }) =>
      errorToDisplay
        ? '1px solid var(--error)'
        : '1px solid var(--color-input-border)'};

    ::placeholder {
      font-size: 12px;
      color: var(--color-input-placeholder);
    }

    :focus {
      outline: 4px solid #c2dbfe;
      border: 1px solid #86b7fe;
    }
  }

  .password-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;

    input {
      width: 100%;
      padding-right: 2.2rem;
    }

    .toggle-icon {
      position: absolute;
      right: 10px;
      display: flex;
      align-items: center;
      color: var(--color-input-placeholder);
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #555;
      }
    }
  }
`;

export const Wrapper = styled.div``;

export const FormInput = styled(Form.Control)`
  font-size: 12px;

  ::placeholder {
    font-size: 12px;
    color: var(--color-input-placeholder);
  }
`;

export const Error = styled.div`
  font-size: 10px;
  color: #dc2229;
  margin-top: 0.2rem;
`;
